const typography = {
    font: {
      extraSmall: 14,
      small: 17,
      medium: 20,
      large: "5vh",
      extraLarge: "6vh",
      
    },
    types: {
      light: "Poppins Light",
      regular: "Poppins Regular",
      normal: "Poppins normal",
      medium: "Poppins Medium",
      extraLight: "Poppins ExtraLight",
      semiBold: "Poppins Bold",
      bold: "Poppins SemiBold",
      inter: "Inter Regular"
    }
  };
  
  export default typography;